<!-- 活动详情 -->
<template>
  <div class="details">
    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="nav-box">
        <img
          src="@/assets/img/position/back.png"
          class="nav-img"
          @click="bindtaps(0)"
          v-if="showImg"
        />
        <span>活动详情</span>
        <div class="nav-item">
          <img
            src="@/assets/img/position/share.png"
            class="nav-img"
            @click="bindtaps(1)"
          />
          <img
            src="@/assets/img/position/backHome.png"
            class="nav-img"
            @click="bindtaps(2)"
          />
        </div>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <!-- 内容 -->
    <div class="details-content">
      <img :src="details.image" class="active-img" />
      <div class="title">
        <p>{{ details.name }}</p>
        <div class="mode">
          <span>免费</span>
          <span>{{ details.apply_number }}人参与</span>
        </div>
      </div>
      <div class="time">
        <p>活动时间</p>
        <p class="really-time">
          {{ details.start_time }}至{{ details.end_time }}
        </p>
      </div>
      <div class="details-contact">
        <p>联系方式</p>
        <div class="item">
          <span class="tips">联系人</span>
          <span class="name">{{ details.contact }}</span>
        </div>
        <div class="item justify">
          <div class="item-self">
            <span class="tips">电话</span>
            <span class="name">{{ details.telphone }}</span>
          </div>
          <img
            src="@/assets/img/home/tel.png"
            class="icons"
            @click="telphone(details.telphone)"
          />
        </div>
        <div class="item">
          <span class="tips">地址</span>
          <span class="name">{{ details.address }}</span>
        </div>
      </div>
      <div class="time">活动详情</div>
      <div v-html="details.detail" class="rich"></div>
    </div>
    <!-- 按钮    -->
    <div class="placeholder">
      <div class="request-btn">
        <van-button
          :disabled="
            details.has_apply == 1 || details.status == 3 || details.status == 1
          "
          class="btns"
          @click="application"
          >{{
            details.status == 1
              ? "即将开始"
              : details.status == 2
              ? details.has_apply
                ? details.has_apply == 0
                  ? "申请"
                  : "已申请"
                : "申请"
              : "已结束"
          }}</van-button
        >
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="overly" v-if="show" @click="show = false"></div>
    <img
      src="../../assets/img/home/share.png"
      class="share"
      v-if="show"
      @click="show = false"
    />
  </div>
</template>

<script>
import { Toast } from "vant";
import { getActiveDetails, joinActive } from "@/api/apiData";
import store from "@/store/index";
export default {
  components: {},
  inject: ["Token", "getWechatApi"],
  data() {
    return {
      showImg:true,
      id: "", //活动id
      details: "", //详情
      showShare: false,
      show: false,
      type: "",
      options: [
        { name: "微信", icon: "wechat", type: "wechat" },
        { name: "微博", icon: "weibo", type: "sina" },
      ],
    };
  },
  computed: {},
  methods: {
    // 返回  分享 收藏
    bindtaps(val) {
      var that = this;
      that.Token(that.gets(val));
    },
    gets(val) {
      var that = this;
      var token = store.state.token;
      if (token != "") {
        if (val == 0) {
          // 返回上一页
          var type = that.type;
          var id = that.id;
          if (type == 0) {
            this.$router.replace({
              name: "Activity",
              params: {
                type: 0,
                id: id,
              },
            });
          } else {
            that.$router.back();
          }
        } else if (val == 1) {
          // 分享
          that.showShare = true;
        } else {
          //   返回首页
          that.$router.replace({
            name: "Home",
          });
        }
      }
    },
    // 拨打电话
    telphone(num) {
      window.location.href = "tel:" + num;
    },
    // 分享选择
    onSelect(option) {
      var type = option.type;
      //新浪微博接口的传参
      if (type == "sina") {
        // //(document.location.href);
        window.open(
          "http://service.weibo.com/share/share.php?url=" +
            document.location.href +
            "?id=" +
            this.id
        );
      }
      // 微信分享
      if (type == "wechat") {
        this.show = true;
      }
      this.showShare = false;
    },
    // 申请
    application() {
      var that = this;
      this.Token(
        (function (id) {
          joinActive({ train_activity_id: that.id }).then((res) => {
            if (res.code == 1) {
              Toast(res.msg);
              that.details.status = 2;
              that.details.has_apply = 1;
            } else {
              Toast(res.msg);
            }
          });
        })()
      );
    },
    // 获取详情
    getDetails() {
      var that = this;
      var id = that.id;
      getActiveDetails({ train_activity_id: id }).then((res) => {
        //(res);
        if (res.code == 1) {
          that.details = res.data;
          console.log(res.data);
          var img;
          if (res.data.image == "") {
            img = "https://ncxtyjrwork.nccloudmedia.com/favicon.ico";
          } else {
            img = res.data.image;
          }
          this.getWechatApi(
            `#${that.$route.fullPath}&share`,
            res.data.name,
            img
          );
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
  },
  mounted() {
    var that = this;
    if (that.$route.query.share === null) {
     
      that.showImg = false;
    }
    that.getDetails();
  },
};
</script>
<style lang='less' scoped>
// 导航栏
.nav-bar {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
  color: rgba(51, 51, 51, 1);
  .nav-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0.32rem;
    z-index: 999;
    background: #fff;
    .nav-img {
      width: 0.4rem;
      height: 0.4rem;
    }
    .nav-item {
      display: flex;
      align-items: center;
      width: 15%;
      justify-content: space-between;
    }
  }
}
.rich {
  // color: #8080;
  padding: 0.2rem 0;
  font-size: 0.3rem;
  line-height: 0.36rem;
}
/deep/.rich img {
  max-width: 100%;
  margin: auto;
}
.overly {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}
.share {
  width: 3rem;
  height: 3rem;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
}
.nav-bar::after {
  content: "";
  display: block;
  height: 0.8rem;
  width: 100%;
}
.placeholder::before {
  content: "";
  display: block;
  height: 1.5rem;
  width: 100%;
  // background: red;
}
// 内容
.details-content {
  padding: 0.2rem 0.32rem;
  .active-img {
    width: 100%;
    height: 4rem;
    border-radius: 0.16rem;
  }
  .title {
    margin-top: 0.16rem;
    p {
      font-size: 0.3rem;
      font-weight: bold;
      line-height: 0.24rem;
      color: rgba(51, 51, 51, 1);
    }
    .mode {
      padding: 0.2rem 0 0;
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.24rem;
      color: rgba(255, 67, 67, 1);
      span:last-child {
        color: rgba(128, 128, 128, 1);
      }
    }
  }
  .time {
    margin-top: 0.5rem;

    font-size: 0.3rem;

    font-weight: bold;

    color: rgba(51, 51, 51, 1);
    .really-time {
      line-height: 0.6rem;
    }
  }
  .details-contact {
    margin-top: 0.5rem;
    p {
      font-size: 0.3rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .justify {
      justify-content: space-between;
    }
    .item {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      .item-self {
        display: flex;
        align-items: center;
        width: 100%;
        .tips {
          width: 12% !important;
        }
      }
      .tips {
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: rgba(128, 128, 128, 1);
        width: 15%;
        align-self: flex-start;
      }
      .name {
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
      }
      .icons {
        width: 0.54rem;
        height: 0.54rem;
        border-radius: 50%;
      }
    }
  }
}
</style>